/*
 * linkPositioner class for vertically positioning links in the sidebar of a content page/window page
 *
 *
 * Version: 1.0
 *
 * Author: Zwaar Contrast
 *
 * Contact: postduif@zwaarcontrast.nl
 *
 * Dependencies: jQuery (1.11.x)
 * 
 */
(function($, window, document, undefined) {
	"use strict";

	/*
	 * 	In the constructor we wrap the element on which the plugin is called on in a jQuey object 
	 *	and expose the passed on options for usage in the init function
	 */
	var LinkPositioner = function(elem, options) {
		this.el = elem;
		this.element = $(elem);
		this.options = options;
	};

	LinkPositioner.prototype = {

		/*
		 *	Default values, which can be overwritten by merging with config on initialisation
		 */
		defaults:{
			linkIdentifier:'link-id',
			sidebarLinkListClass: 'window-content-links-list',
			sidebarLinkClass:'window-content-links-item',
			sidebarLinkVisibileClass:'is-window-content-links-item-visible',
			contentLinkClass:'window-content-links-body-link',
			resizeDebounce:50,
			horizontalThreshold:1240,
			debug : true
		},

		/*
		 *	Initialisation funtion, read passed config and call necessary functions to launch our plugin like binding events and setting status variables
		 */
		init: function() {
			//Get the options and merge with defaults
			this.config = $.extend({}, this.defaults, this.options);

			//Status, like animating, initialised or loaded
			this.showSidebarLinks = true;

			//Call functions for initialisation
			this.getElements();

			if(this.sidebarLinks.length>0){
				this.getData();
				this.bindResize();
				this.bindLoad();
				this.bindEvents();

				//Initial positioning
				this.positionLinks();
			}

			this.checkWidth();

			return this;
		},
		getElements:function(){
			var _self = this;
			this.window = $(window);

			this.sidebarLinkList = this.element.find('.'+this.config.sidebarLinkListClass);
			this.sidebarLinks = [];
			this.contentLinks = this.element.find('.'+this.config.contentLinkClass);

			this.sidebarLinkList.html('');
			$.each(this.contentLinks, function(index,el){
				var linkid,site,desc,href,school,listitem;

				linkid = $(el).data('link-id');
				site = $(el).data('site');
				desc = $(el).data('shortdesc');
				href = $(el).attr('href');
				school = $(el).data('school');

				if(linkid && site && desc && href){
					listitem = '<li class="'+_self.config.sidebarLinkClass;
					listitem += (school == '1') ? ' '+_self.config.sidebarLinkClass+'-school' : '';
					listitem += '" id="'+linkid+'" data-link-id="'+linkid+'">';
					listitem += '<a href="'+href+'" class="window-content-links-link">';
					listitem += '<span class="window-content-links-link-about">over</span>';
					listitem += '<span class="window-content-links-link-title">'+desc+'</span>';
					listitem += '<span class="window-content-links-link-source">op '+site+'</span>';
					listitem += '<span class="window-content-links-link-go">ga</span></a></li>';

					listitem = $.parseHTML(listitem);
					console.log(linkid,site,desc,href,listitem);
					_self.sidebarLinks.push(listitem[0]);
					_self.sidebarLinkList.append(listitem);
				}

			});

			//Check values
			if(this.config.debug){
				if(this.sidebarLinks.length==0){
					console.log('No sidebar links found');
				}
				if(this.contentLinks.length==0){
					console.log('No content links found');
				}
				if(this.contentLinks.length!== this.sidebarLinks.length){
					console.log('Not the same amount of sidebar and content links found');
				}
			}

			//Get parent for link positioning
			this.sidebarLinksParent = this.sidebarLinkList;
		},
		getData: function(){
			//Variables
			var sidebarIdentifier,contentIdentifier,foundContentLink, _self =this ;
			this.pairedLinks = [];

			for (var i = this.sidebarLinks.length - 1; i >= 0; i--) {
				//Get identifier
				sidebarIdentifier = $(this.sidebarLinks[i]).attr('data-'+this.config.linkIdentifier);
				
				//Check sidebarIdentifier
				if(this.config.debug){
					if(!sidebarIdentifier || sidebarIdentifier.length == 0){
						console.log('No identifier found to match links against in sidebar');
					}
				}

				foundContentLink = _self.contentLinks.filter(function(i,el){
						//Get identifier
						contentIdentifier = $(el).attr('data-'+_self.config.linkIdentifier);

						//Check contentIdentifier
						if(_self.config.debug){
							if(!contentIdentifier || contentIdentifier.length == 0){
								console.log('No identifier found to match links against in sidebar');
							}
						}
						return contentIdentifier===sidebarIdentifier;
				})[0];

				if(foundContentLink){
					this.pairedLinks.push({
						'content' : foundContentLink,
						'sidebar':_self.sidebarLinks[i],
						'top':0
					});
				}
			}

			if(this.config.debug){
				if(this.pairedLinks.length !== this.sidebarLinks.length){
					console.log('Identifiers don\'t match up in correct amounts');
				}
			}
		},
		bindResize:function(){
			//Variables and reference to self
			var TO = false, _self = this;

			//We make this construct to debounce the resize event,
			//so it doesn't call our functions a bazillion times
			this.window.resize(function() {
				if (TO !== false){
					clearTimeout(TO);
				}
				TO = setTimeout(function(){
					//Do stuff here
					_self.checkWidth();
					_self.positionLinks();
				}, _self.config.resizeDebounce);
			});
		},
		bindLoad:function(){
			var _self = this;
			this.window.load(function(){
				_self.positionLinks();
			});
		},
		bindEvents:function(){
			var _self = this;
			this.window.off('repositionLinks').on('repositionLinks',function(){
				_self.positionLinks();
			})
		},
		checkWidth:function(){
			//Check threshold
			if(this.window.width()<this.config.horizontalThreshold){
				//Check switch necessary
				if(this.showSidebarLinks){
					this.showSidebarLinks = false;
					this.toggleVisibility();
				}
			}else{
				//Check switch necessary
				if(!this.showSidebarLinks){
					this.showSidebarLinks = true;
					this.toggleVisibility();
				}
			}
		},
		positionLinks:function(){
			var contentLink,sidebarLink;
			for (var i = this.pairedLinks.length - 1; i >= 0; i--) {
				//Cache elements for convenience
				contentLink = this.pairedLinks[i].content;
				sidebarLink = this.pairedLinks[i].sidebar;

				//Set top
				if(this.pairedLinks[i].top != contentLink.offsetTop){
					this.pairedLinks[i].top = contentLink.offsetTop;
					sidebarLink.style.top = contentLink.offsetTop+'px';
					sidebarLink.classList.add(this.config.sidebarLinkVisibileClass);
					//Debug
					if(this.config.debug){
						console.log('Set position of link');
					}
				}
			}
		},
		toggleVisibility:function(){
			//Check state
			if(this.showSidebarLinks){
				this.sidebarLinksParent.append(this.cachedSidebarLinks);
			}else{
				this.cachedSidebarLinks = $(this.sidebarLinks).detach();
			}
			//Debug
			if(this.config.debug){
				console.log('Toggle visibility of links');
			}
		}
	};

	//Extend Jquery with the LinkPositioner function/object
	$.fn.LinkPositioner = function(options) {
		//Do for each of the passed elements
		return this.each(function() {
			//Construct new LinkPositioner object and call initialisation function
			new LinkPositioner(this, options).init();
		});
	};
})(jQuery, window, document);